<script setup lang="ts">
const router = useRouter();

const ending = 'Hahnemühle';
const pageTitle = computed(() => {
	const title = router.currentRoute.value.meta.title;
	if (title) {
		return `${title} · ${ending}`;
	}

	return ending;
});

const canonicalBase = useHelpPortalURL();

useHead({
	link: [
		{ rel: 'icon', type: 'image/png', href: '/favicon-96x96.png', sizes: '96x96' },
		{ rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
		{ rel: 'shortcut icon', href: '/favicon.ico' },
		{ rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
		{ rel: 'manifest', href: '/site.webmanifest' },
		{ rel: 'canonical', href: () => canonicalBase + router.currentRoute.value.path },
	],
});

useSeoMeta({
	title: 'Hahnemühle Help',
	ogTitle: 'Hahnemühle Help',
	description: '',
	ogDescription: '',
	msapplicationTileColor: '#FFF',
	themeColor: '#FFF',
});

// Enable when cookies are present
// const cookieAppId: CookieApp = 'help';
// useCookieScripts(cookieAppId);
</script>

<template>
	<div>
		<NuxtLoadingIndicator :throttle="200" :color="false" />

		<NuxtLayout>
			<Title>
				{{ pageTitle ?? ending }}
			</Title>
			<NuxtPage />
		</NuxtLayout>

		<!-- <HmCookieConsent :app="cookieAppId" /> -->
		<HmImprint />
	</div>
</template>

<style lang="scss">
:root
{
	scroll-behavior:smooth;
}
</style>
